import type { ReactNode } from "react";

import { AuthBrandPanel } from "@/components/auth/AuthBrandPanel";
import { AuthMobileBrandHeader } from "@/components/auth/AuthMobileBrandHeader";
import type { AuthMode } from "@/components/auth/authMode";
import { PrivacyFooter } from "@/components/PrivacyFooter";
import { cn } from "@/lib/utils";

export interface AuthLayoutProps {
  mode: AuthMode;
  children: ReactNode;
  contentClassName?: string;
  hasPendingInvite?: boolean;
}

/**
 * Auth shell: full-bleed midnight brand header on mobile; two-column
 * branded card on md+ with AuthBrandPanel beside the Clerk form.
 */
export function AuthLayout({ mode, children, contentClassName, hasPendingInvite }: AuthLayoutProps) {
  return (
    <div className="flex min-h-svh flex-col bg-background">
      <AuthMobileBrandHeader mode={mode} hasPendingInvite={hasPendingInvite} />

      <div className="flex flex-1 flex-col md:items-center md:justify-center md:bg-muted md:p-8">
        <div className="flex w-full flex-1 flex-col md:grid md:min-h-[42rem] md:max-w-5xl md:grid-cols-2 md:items-stretch md:overflow-hidden md:rounded-xl md:border md:bg-card">
          <AuthBrandPanel mode={mode} hasPendingInvite={hasPendingInvite} />
          <div className="flex flex-1 flex-col items-center justify-center gap-6 px-6 py-8 md:overflow-y-auto md:p-10">
            <div className={cn("w-full max-w-sm md:w-4/5 md:max-w-none", contentClassName)}>
              {children}
            </div>
          </div>
        </div>
      </div>

      <PrivacyFooter />
    </div>
  );
}
